import axios from 'axios'

const state = {
  programs: []
}

const getters = {
  getPrograms (state) {
    return state.programs
  }
}

const mutations = {
  setPrograms (state, data) {
    state.programs = data
  }
}

const actions = {
  fetchReport ({dispatch, state, commit, rootGetters}, data) {
    return axios({
      url: process.env.API_URL + `/ws/compliance/course/${data.courseId}/program/${data.programId}/report`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },
  fetchProgram ({dispatch, state, commit, rootGetters}, data) {
    return axios({
      url: process.env.API_URL + `/ws/compliance/course/${data.courseId}/program/${data.programId}`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },
  fetchUser ({dispatch, state, commit, rootGetters}, data) {
    const url = data.courseId === 68 ? process.env.API_URL + `/ws/playerservice/user/${data.username}` : process.env.API_URL + `/ws/playerservice/user/${data.username}?deck=${data.courseId}`
    return axios({
      url,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },
  newEventDetails ({dispatch, state, commit, rootGetters}, programId) {
    return axios({
      url: process.env.API_URL + `/ws/compliance/program/${programId}/new-event`,
      method: 'GET',
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  },
  createEvent ({dispatch, state, commit, rootGetters}, data) {
    commit('setPayLoading', true)
    return axios({
      url: process.env.API_URL + `/ws/compliance/program/${data.programId}/event`,
      method: 'POST',
      data: data.data,
      headers: {
        Authorization: 'Bearer ' + rootGetters.token
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/complianceProgram.js